<template>
  <div>
    <div class="card-title">
      <form @submit.prevent="Upload()">
        <div class="row">
        <div class="col py-4 text-left px-4 mx-2">
          <div class="form-group" >
                  <select id="bank" class="form-control" v-model="sr_schoolid" @input="getStudents" required>
                  <option value="">Select School</option>
                  <option v-for="(school, i) in schools" :value="school.Sz_orgid" :key="i">{{school.sz_orgname | capitalize}}</option>
                  </select>
              </div> 
        </div>
        <div class="col py-4 text-right px-4 mx-2">
            <div class="custom-file">
              <input class="custom-file" type="file" id="file" ref="uploadFile" accept=".xlsx" v-on:change="handleFileUpload()"/>
            </div>
          <div class="">
            <button type="submit" class="btn btn-success" >Upload</button>
            <button type="button" class="btn btn-primary" @click="saveSchool" >Save</button>
          </div>
        </div>
      </div>
      </form>
    </div>
    <div class="card mb-4">
      <div class="card-body">
        <div class="input-group md-form form-sm form-2 pl-0">
          <input
            class="form-control my-0 py-1 pl-3"
            style="border-radius: 30px;"
            type="text"
            v-model="filter_name"
            placeholder="Search student..."
            aria-label="Search"
          />
        </div>
        <div class="text-center py-2" v-if="filter_name">
          <span class="badge badge-pill badge-primary">
            {{ filter_name }}
            <span class="remove-search-btn px-2" @click="removeComplaint(i)">&times;</span>
          </span>
        </div>
        <div class="table-responsive">
          <!--Table-->

          <table class="table table-hover">
            <!--Table head-->
            <thead class="success-color-dark z-depth-2">
              <tr class="text-white">
                <th>#</th>
                <th scope="col" v-for="(header,index) in headers" :key="index">{{header.text}}</th>
              </tr>
            </thead>
            <!--Table head-->
            <!--Table body-->
            <tbody >
                <tr v-for="(detail, i) in theData" :key="i">

                <th scope="row">{{i+1}}</th>
                <td class="py-3">{{detail.studentid | capitalize}}</td>
                <td class="py-3 px-2">{{detail.admissionno | capitalize}}</td>
                <td class="py-3 px-2">{{detail.fname | capitalize}}</td>
                <td class="py-3 px-2">{{detail.lname | capitalize}}</td>
                <td class="py-3 px-2">{{detail.oname | capitalize}}</td>
                <td class="py-3 px-2">{{detail.szclass | capitalize}}</td>
              </tr>
            </tbody>
            <!-- <tbody >
                <h1>Please select a school</h1>
            </tbody> -->
            <!--Table body-->
          </table>
          <div class="text-center mt-2" v-if="loading">
                <i  style="font-size:80px" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            </div> 
            <p v-if="tabdata.length === 0 && !loading" class="text-muted text-center lead font-weight-bold mt-2">
                Please no data in selected school
              </p>
          <div class="d-flex justify-content-center">
          <!--Pagination -->
                        <nav class="my-4 pt-2">
                            <ul class="pagination pagination-circle pg-blue mb-0">
                                <!--Arrow left-->
                                <li class="page-item " :class="{'disabled': (currPage === 1)}" 
            @click.prevent="setPage(currPage-1)">
                                    <a class="page-link" aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span class="sr-only">Previous</span>
                                        </a>
                                </li>
                                <!--Numbers-->
                                <li class="page-item" v-for="(n,i) in totalPage" :key="i" :class="{'active': (currPage === (n))}" 
            @click.prevent="setPage(n)"><a class="page-link">{{n}}</a></li>
                                <!--Arrow right-->
                                <li class="page-item" :class="{'disabled': (currPage === totalPage)}" 
            @click.prevent="setPage(currPage+1)">
                                    <a class="page-link" aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span class="sr-only">Next</span>
                                        </a>
                                </li>
                            </ul> 
                        </nav>
                        <!--/Pagination -->
          </div>
            <textarea style="display: none" id="base64" rows="5"></textarea>
        </div>
        <!--Table-->
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/network/Base.js";
import { mapState } from "vuex";
var theFiles = null;
// import EmployeeService from '@/network/corporate/employee.js'
export default {
   props: {
    id: {
      default: 6
    }
  },
  data() {
    return {
      loading: false,
      search: "",
      saveAble: true,
      schools: [],
      perPage: 10,
      pagination: {},
      selectedIndex: 0,
      tabdata: [],
      sr_file: '',
      sr_schoolid:'',
      sr_filename: '',
      headers: [
        { text: "ADMISSION NUMBER", value: "id", align: "center" },
        { text: "STUDENT ID", value: "school", sortable: true },
        // { text: "ADDRESS", value: "address" },
        { text: "FIRST NAME", value: "fname" },
        { text: "LAST NAME", value: "lname" },
        { text: "OTHER NAME", value: "oname" },
        { text: "CLASS", value: "class" }
      ],
      countOfPage: 10,
    currPage: 1,
    filter_name: ''
    };
  },
  filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.toUpperCase()
      }
    },

  methods: {
    setPage(idx){
      if( idx <= 0 || idx > this.totalPage ){
        return;
      }
      this.currPage = idx;
    },
    Upload(){
      
        //console.log(this.sr_filename);
      if(this.sr_filename == null || this.sr_filename == '')
      {
           return this.$snotify.error('No File Selected', {
                  timeout: 2000,
                      showProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true,
                      position: "centerTop"
                  })
      }
      this.loading = true
    this.$Progress.start()
    // console.log(this.sr_file[PromiseValue])
          http().post( '/UploadStudentFile', {sr_file: document.getElementById('base64').value, sr_filename: this.sr_filename}).
          then((res) => {
            this.tabdata = res.data
            this.saveAble = false
            this.$snotify.success('The file has been uploaded', {
                  timeout: 2000,
                      showProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true,
                      position: "centerTop"
                  })
            
      })
      .catch(error => {
        this.$snotify.error('Sorry, file not uploaded')
      })
      .finally(() => {
          this.loading = false
      })
    },
    saveSchool(){
     //
        // console.log(this.sr_filename);
      if(this.sr_filename == null || this.sr_filename == '')
      {
           return this.$snotify.error('No File Selected', {
                  timeout: 2000,
                      showProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true,
                      position: "centerTop"
                  })
      }
      this.loading = true
     this.$Progress.start()
      http().post( '/SaveUploadedStudentFile', {sr_filename: this.sr_filename, sz_schoolid: this.sr_schoolid}).
          then((res) => {
            // console.log(res)
            //console.log(res.data);
            //console.log(res.data.success);
            //console.log(res.data.message.reason);
            if(res.data.success == false){
               this.$snotify.error(res.data.message.reason)
            }else if(res.data.success == true)
            {
                //this.$snotify.success(res.message.reason)
                 this.$snotify.success(res.data.message.reason, {
                  timeout: 2000,
                      showProgressBar: false,
                      closeOnClick: false,
                      pauseOnHover: true,
                      position: "centerTop"
                  })
            }
      })
         .catch(error => {
         // console.log(error);
          this.loading = false;

          // this.$Progress.finish()
          if (error.response) {
            // this.$Progress.finish()
            if (error.response.status === 500) {
              return this.$snotify.error(
                "An error occured whiles saving your upload"
              );
            } else if (error.response.status === 200) {
              return this.$snotify.error("No school with such ID in the system");
            }
            return this.$snotify.error("School doesn't exist");
          }
          return this.$snotify.error(
            "Could not get list. Check your internet connection!"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getStudent(){
      this.loading = true
      this.sr_filename = '',
            http().post( '/GetStudentList_API', {sz_schoolid: this.sr_schoolid}).

      then(({data}) => {
        this.tabdata = data
        if (this.tabdata == -1){
          this.tabdata = []
        } else {
        this.$snotify.success('Success')
        }
          // console.log(data)
      })
        .catch(error => {
          console.log(error);
          this.loading = false;

          // this.$Progress.finish()
          if (error.response) {
            // this.$Progress.finish()
            if (error.response.status === 500) {
              return this.$snotify.error(
                "An error occured whiles getting list"
              );
            } else if (error.response.status === 200) {
              return this.$snotify.error("No school with such id in the system");
            }
            return this.$snotify.error("School doesn't exist");
          }
          return this.$snotify.error(
            "Could not get list. Check your internet connection!"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getStudents(value){
      this.sr_schoolid = value.target.value
      this.getStudent()
    },
      //   setPage(p) {
      //   this.pagination = this.paginator(this.tabdata.length, p);
      //   console.log(this.pagination)
      // },
      // paginate(data) {
      //   return _.slice(data, this.pagination.startIndex, this.pagination.endIndex + 1)
      // },
      // paginator(totalItems, currentPage) {
      //   var startIndex = (currentPage - 1) * this.perPage,
      //   endIndex = Math.min(startIndex + this.perPage - 1, totalItems - 1);
      //   return {
      //     currentPage: currentPage,
      //     startIndex: startIndex,
      //     endIndex: endIndex,
      //     pages: _.range(1, Math.ceil(totalItems / this.perPage) + 1)
      //   };
      // },
    handleFileUpload(){
       let f = this.$refs.uploadFile.files[0]
       // console.log(f)
      const reader = new FileReader();

  reader.onload = (function(theFile) {
    return function(e) {
      var binaryData = e.target.result;
      //Converting Binary Data to base 64
      let base64String = window.btoa(binaryData);
      //showing file converted to base64
      document.getElementById('base64').value = base64String;
      // alert('File converted to base64 successfuly!\nCheck in Textarea');
    };
  })(f)
  // Read in the image file as a data URL.

  reader.readAsBinaryString(f);
  // // toBase64()
      this.sr_filename = this.$refs.uploadFile.files[0].name

      // console.log(this.sr_file)
      this.saveAble = true
      this.$snotify.info('The file "' + this.sr_filename +  '" has been selected. Please Upload', {
        timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            position: "centerTop"
        })
      },
  },

  computed: {
    ...mapState({
      providerid: state => state.provider.provider_id,
      selecteSchool: state => state.provider.school,
    }),

    // tableData() {
    //   return this.tabdata
    //     .map(el => ({
    //       school: el["studentid"],
    //       id: el["admissionno"],
    //       fname: el["fname"],
    //       oname: el["oname"],
    //       lname: el["lname"],
    //       class: el["szclass"]
    //     }))
    //     .filter(el => {
    //       let search = this.search.toLowerCase();
    //       if (
    //         el.school
    //           .toString()
    //           .toLowerCase()
    //           .search(search) > -1
    //       )
    //         return true;
    //       else return false;
    //     });
    // },
    filteredRows: function(){
      var filter_name = this.filter_name.toLowerCase();
      return ( this.filter_name.trim() !== '' ) ? 
        this.tabdata.filter((d) => { return d.fname.toLowerCase().indexOf(filter_name) > -1 || d.oname.toLowerCase().indexOf(filter_name) > -1 || d.lname.toLowerCase().indexOf(filter_name) > -1}) : 
      this.tabdata;
    },
    pageStart: function(){
        return (this.currPage - 1) * this.countOfPage;
      },
    totalPage: function(){
      return Math.ceil(this.filteredRows.length / this.countOfPage);
    },
    theData(){
      // console.log(this.filteredRows)
      return this.filteredRows.slice(this.pageStart, this.pageStart + this.countOfPage)
    },
  },
  created() {
     this.setPage(1)
    this.$Progress.start();
    this.loading = true;
    http()
      .post("/ListProvidersSchools/", { sz_providerid: this.providerid })
      .then(({ data }) => {
        this.schools = data;
      })
      .catch(err => {
        this.$snotify.error("Could not get the list of schools");
        this.$Progress.finish();
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped>
.hm-gradient {
  background-image: linear-gradient(
    to top,
    #f3e7e9 0%,
    #e3eeff 99%,
    #e3eeff 100%
  );
}
.darken-grey-text {
  color: #2e2e2e;
}
.input-group.md-form.form-sm.form-2 input {
  border: 1px solid #bdbdbd;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.input-group.md-form.form-sm.form-2 input.purple-border {
  border: 1px solid #9e9e9e;
}
.input-group.md-form.form-sm.form-2
  input[type="text"]:focus:not([readonly]).purple-border {
  border: 1px solid #ba68c8;
  box-shadow: none;
}
.form-2 .input-group-addon {
  border: 1px solid #ba68c8;
}
.danger-text {
  color: #ff3547;
}
.success-text {
  color: #00c851;
}
.table-bordered.red-border,
.table-bordered.red-border th,
.table-bordered.red-border td {
  border: 1px solid #ff3547 !important;
}
.table.table-bordered th {
  text-align: center;
}
.remove-search-btn {
  cursor: pointer;
}
.sidenav {
  height: 100%;
  display: none;
  position: fixed;
  z-index: 2;
  top: 0;
  right: 0;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  background-color: #f6f9fd;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}
</style>
